import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AboutSection"] */ "/vercel/path0/src/components/home/AboutSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AudiencesSection"] */ "/vercel/path0/src/components/home/AudiencesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClosingSection"] */ "/vercel/path0/src/components/home/ClosingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ComingSoonSection"] */ "/vercel/path0/src/components/home/ComingSoonSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeedbackForm"] */ "/vercel/path0/src/components/home/FeedbackForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorksSection"] */ "/vercel/path0/src/components/home/HowItWorksSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingSection"] */ "/vercel/path0/src/components/home/PricingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/vercel/path0/src/components/home/SiteHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustStrip"] */ "/vercel/path0/src/components/home/TrustStrip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyGwtSection"] */ "/vercel/path0/src/components/home/WhyGwtSection.tsx");
